import gql from 'graphql-tag';

export const ContentIdByReferenceIdQuery = gql`
	query ContentIdByReferenceIdQueryWhiteboards($id: String!) {
		contentIdByReferenceId(referenceId: $id)
	}
`;
